
<div class="quick-action">
  <div class="tooltip-quick-action" *ngFor="let action of quickActions">
    <button class="quick-btn"> <img [src]="action.icon" (click)="quickAction(action.section)"/></button>
    <div class="tooltip-text">{{action.name}}</div>
  </div>
</div>